export default __webpack_public_path__ + "static/media/undraw_Taken_re_yn20.98a9023b.svg";